import i18n from '@/utils/i18n';
import { useCallback, useMemo, useState } from 'react';

export enum FilterType {
  ALL = 'ALL',
  CALL_SHEET = 'CALL_SHEET',
  UNSCHEDULED = 'UNSCHEDULED',
}

export const useCallSheetFiltering = () => {
  const [filter, setFilter] = useState<FilterType>(FilterType.ALL);

  const selectAll = useCallback(() => {
    setFilter(FilterType.ALL);
  }, []);

  const selectCallSheet = useCallback(() => {
    setFilter(FilterType.CALL_SHEET);
  }, []);

  const selectUnscheduled = useCallback(() => {
    setFilter(FilterType.UNSCHEDULED);
  }, []);

  const pillButtonProps = useMemo(() => {
    return [
      {
        active: filter === FilterType.ALL,
        collapsed: false,
        label: i18n.t('current_orders.filter.all'),
        onClear: undefined,
        onPress: selectAll,
      },
      {
        active: filter === FilterType.CALL_SHEET,
        collapsed: false,
        label: i18n.t('current_orders.filter.call_sheet'),
        onClear: undefined,
        onPress: selectCallSheet,
      },
      {
        active: filter === FilterType.UNSCHEDULED,
        collapsed: false,
        label: i18n.t('current_orders.filter.unscheduled'),
        onClear: undefined,
        onPress: selectUnscheduled,
      },
    ];
  }, [filter, selectAll, selectCallSheet, selectUnscheduled]);

  return {
    filter,
    pillButtonProps,
  };
};
